import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cl-bulk-action',
    templateUrl: './bulk-action.component.html'
})
export class BulkActionComponent {
    static $name: string = 'clBulkAction';

    @Output() bulkAction = new EventEmitter();
    @Input() icon: string;
    @Input() materialIcon: string;
    @Input() disabled: boolean;
    @Input() tooltip?: string;

    constructor(
    ) {
    }

    executeAction() {
        this.bulkAction.emit();
    }
}
